import React from 'react';
import { InfoIcon } from "../../../ui";
import copyPng from "../../../images/copy.png";

export default function InfoIconExtended(params: { label: string; }) {

  function copyToClipboard() {
    navigator.clipboard.writeText(params.label);
  }

  return (
    <InfoIcon testId="infoIconInvoicesData">
      {params.label}
      <img src={copyPng} className="copy-icon" onClick={copyToClipboard} />
    </InfoIcon>
  );
}